import { render, staticRenderFns } from "./PaymentsModal.vue?vue&type=template&id=fdd07590&"
import script from "./PaymentsModal.vue?vue&type=script&lang=js&"
export * from "./PaymentsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports